import { takeLatest, select, put } from 'redux-saga/effects';
import { DataLayer } from '@grandvisionhq/analytics';
import { Selectors, State } from '@grandvisionhq/auth';
import { PAGE_VIEW } from '../actions.js';
import { createUser } from '../utils.js';

function* onPageView(action) {
    const auth = yield select(Selectors.getAuth);
    // can't do anything meaningful without auth data
    if (State.isUninitialized(auth)) {
        return;
    }
    const data = makePageView(auth, action.payload);
    yield put(DataLayer.Actions.pushEvent(data));
}
function makePageView(authState, payload) {
    const { currentRoute , hideUserData  } = payload;
    return {
        event: 'user_data_loaded',
        page: {
            type: `account - ${currentRoute}`
        },
        user: createUser(authState, hideUserData)
    };
}
/**
 * Main export
 */ var PageViewSagas = [
    takeLatest(PAGE_VIEW, onPageView)
];

export { PageViewSagas as default, onPageView };
//# sourceMappingURL=pageview.js.map
